import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ReopenPerformanceReviewProcessDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { DeadlinePicker } from 'modules/performance_process/components/review/forms/Deadline'

export const ReopenReviewModal: React.FC<{
  reviewId: number
  onClose?: () => void
}> = ({ reviewId, onClose }) => {
  const [newEndDate, setNewEndDate] = React.useState<Date | null>(null)
  const [reopenReviewMutation, { loading: reopeningReview }] = useMutation(
    ReopenPerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.reopenPerformanceReviewProcess,
    }
  )

  const reopenReview = async () => {
    if (!newEndDate) return
    const response = await reopenReviewMutation({
      variables: {
        id: Number(reviewId),
        endsAt: newEndDate.toISOString(),
      },
    })

    const result = handleResult(response, () => null)
    onClose?.()
    return result
  }

  return (
    <Modal
      title={i18n.t('performance_process.reviews.reopen_review_button')}
      description={i18n.t('performance_process.reviews.reopen_review_modal.description')}
      illustration={'alert'}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose} disabled={reopeningReview}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={() => reopenReview()} disabled={reopeningReview || !newEndDate}>
            {i18n.t('performance_process.reviews.reopen_review_button')}
          </Button>
        </>
      }
    >
      <Box gap="s32">
        <Box gap="s16">
          <Text size="400" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.timeline_section.deadline.title')}
          </Text>
          <Text.Normal>
            {i18n.t('performance_process.reviews.reopen_review_modal.set_date')}
          </Text.Normal>
          <Box flexDirection="row" gap="s16">
            <DeadlinePicker date={newEndDate} onChange={(date) => setNewEndDate(date)} />
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
